var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1687 4.47891C27.5156 3.61758 28.3406 3.0625 29.25 3.0625H39.75C40.9969 3.0625 42 4.08652 42 5.35938V16.0781C42 17.0064 41.4563 17.8486 40.6125 18.2027C39.7688 18.5568 38.8031 18.3654 38.1562 17.7051L35.025 14.5086L30.0938 19.5426C31.9219 22.2605 33 25.5432 33 29.0938C33 38.3961 25.6125 45.9375 16.5 45.9375C7.3875 45.9375 0 38.3961 0 29.0938C0 19.7914 7.3875 12.25 16.5 12.25C19.9688 12.25 23.1937 13.341 25.8562 15.2168L30.7875 10.1828L27.6562 6.98633C27.0094 6.32598 26.8219 5.34023 27.1687 4.47891ZM16.5 39.8125C22.3031 39.8125 27 35.0178 27 29.0938C27 23.1697 22.3031 18.375 16.5 18.375C10.6969 18.375 6 23.1697 6 29.0938C6 35.0178 10.6969 39.8125 16.5 39.8125Z",
    fill: "#FBC2B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.977f92992c731aeb2b1d30cfc367dfed.svg";
export { ForwardRef as ReactComponent };